export interface ReferenceReply {
	customer?: string;
	reply: string;
}

const SEPARATOR = '\n\n---\n\n';
const CUSTOMER_LINE = /^\[Customer: ([\s\S]*?)\]\n([\s\S]*)$/;

/**
 * A compiled Reply's examples, as the compiler writes them into an LLM_GENERATE `message`:
 * separated by a `---` line, each with an optional `[Customer: …]` first line. Null when the
 * message is not in that shape, so the caller shows it as plain text.
 */
export function parseReferenceReplies(message: string): ReferenceReply[] | null {
	const chunks = message.split(SEPARATOR).map((chunk) => chunk.trim());
	const replies = chunks.map((chunk): ReferenceReply => {
		const match = CUSTOMER_LINE.exec(chunk);
		return match ? { customer: match[1]!.trim(), reply: match[2]!.trim() } : { reply: chunk };
	});
	// One chunk with no customer line is just text; an empty reply means the shape is something else.
	if (chunks.length === 1 && !replies[0]!.customer) return null;
	return replies.every((r) => r.reply) ? replies : null;
}
